import React from 'react';

export const GripDotsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 16 16" fill="currentColor" className={className}>
    <circle cx="5.5" cy="3" r="1.2" />
    <circle cx="10.5" cy="3" r="1.2" />
    <circle cx="5.5" cy="8" r="1.2" />
    <circle cx="10.5" cy="8" r="1.2" />
    <circle cx="5.5" cy="13" r="1.2" />
    <circle cx="10.5" cy="13" r="1.2" />
  </svg>
);

// eslint-disable-next-line react-refresh/only-export-components -- utility paired with GripDotsIcon component in this shared file; splitting needs ~10 import-site updates
export const smoothScroll = (
  el: HTMLElement,
  targetTop: number,
  targetLeft: number,
  animIdRef: { current: number },
) => {
  cancelAnimationFrame(animIdRef.current);
  const startTop = el.scrollTop;
  const startLeft = el.scrollLeft;
  const distTop = targetTop - startTop;
  const distLeft = targetLeft - startLeft;
  const duration = 250;
  const start = performance.now();
  const step = (now: number) => {
    const t = Math.min((now - start) / duration, 1);
    const ease = t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2;
    el.scrollTop = startTop + distTop * ease;
    el.scrollLeft = startLeft + distLeft * ease;
    if (t < 1) animIdRef.current = requestAnimationFrame(step);
  };
  animIdRef.current = requestAnimationFrame(step);
};

// eslint-disable-next-line react-refresh/only-export-components -- utility paired with GripDotsIcon component in this shared file; splitting needs ~10 import-site updates
export const getColWidth = (
  columnId: string,
  baseWidth: number,
  minSize: number | undefined,
  pinnedSet?: Set<string>,
  filterableSet?: Set<string>,
  pinIconExtraPx = 22,
  filterIconExtraPx = 24,
): number => {
  const base = Math.max(baseWidth || 100, minSize ?? 0);
  return base
    + (filterableSet && filterableSet.has(columnId) ? filterIconExtraPx : 0)
    + (pinnedSet && pinnedSet.has(columnId) && columnId !== 'rowNumber' ? pinIconExtraPx : 0);
};
